function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

import { combine, generateUUID, RequestType, ResourceType, toServerDuration, relativeToClocks, createTaskQueue } from '@datadog/browser-core';
import { RumPerformanceEntryType, createPerformanceObservable } from '../../browser/performanceObservable';
import { RumEventType } from '../../rawRumEvent.types';
import { createSpanIdentifier } from '../tracing/identifier';
import { matchRequestResourceEntry } from './matchRequestResourceEntry';
import { computeResourceEntryDetails, computeResourceEntryDuration, computeResourceEntryType, computeResourceEntrySize, computeResourceEntryProtocol, computeResourceEntryDeliveryType, isResourceEntryRequestType, sanitizeIfLongDataUrl } from './resourceUtils';
import { retrieveInitialDocumentResourceTiming } from './retrieveInitialDocumentResourceTiming';
import { createRequestRegistry } from './requestRegistry';
import { extractGraphQlMetadata, findGraphQlConfiguration } from './graphql';
export function startResourceCollection(lifeCycle, configuration, pageStateHistory) {
  var taskQueue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : createTaskQueue();
  var retrieveInitialDocumentResourceTimingImpl = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : retrieveInitialDocumentResourceTiming;
  var requestRegistry;
  var isEarlyRequestCollectionEnabled = configuration.trackEarlyRequests;

  if (isEarlyRequestCollectionEnabled) {
    requestRegistry = createRequestRegistry(lifeCycle);
  } else {
    lifeCycle.subscribe(8
    /* LifeCycleEventType.REQUEST_COMPLETED */
    , function (request) {
      handleResource(function () {
        return processRequest(request, configuration, pageStateHistory);
      });
    });
  }

  var performanceResourceSubscription = createPerformanceObservable(configuration, {
    type: RumPerformanceEntryType.RESOURCE,
    buffered: true
  }).subscribe(function (entries) {
    var _iterator = _createForOfIteratorHelper(entries),
        _step;

    try {
      var _loop = function _loop() {
        var entry = _step.value;

        if (isEarlyRequestCollectionEnabled || !isResourceEntryRequestType(entry)) {
          handleResource(function () {
            return processResourceEntry(entry, configuration, pageStateHistory, requestRegistry);
          });
        }
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
  retrieveInitialDocumentResourceTimingImpl(configuration, function (timing) {
    handleResource(function () {
      return processResourceEntry(timing, configuration, pageStateHistory, requestRegistry);
    });
  });

  function handleResource(computeRawEvent) {
    taskQueue.push(function () {
      var rawEvent = computeRawEvent();

      if (rawEvent) {
        lifeCycle.notify(12
        /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */
        , rawEvent);
      }
    });
  }

  return {
    stop: function stop() {
      taskQueue.stop();
      performanceResourceSubscription.unsubscribe();
    }
  };
}

function processRequest(request, configuration, pageStateHistory) {
  var matchingTiming = matchRequestResourceEntry(request);
  return assembleResource(matchingTiming, request, pageStateHistory, configuration);
}

function processResourceEntry(entry, configuration, pageStateHistory, requestRegistry) {
  var matchingRequest = isResourceEntryRequestType(entry) && requestRegistry ? requestRegistry.getMatchingRequest(entry) : undefined;
  return assembleResource(entry, matchingRequest, pageStateHistory, configuration);
} // TODO: In the future, the `entry` parameter should be required, making things simpler.


function assembleResource(entry, request, pageStateHistory, configuration) {
  if (!entry && !request) {
    return;
  }

  var tracingInfo = request ? computeRequestTracingInfo(request, configuration) : computeResourceEntryTracingInfo(entry, configuration);

  if (!configuration.trackResources && !tracingInfo) {
    return;
  }

  var startClocks = entry ? relativeToClocks(entry.startTime) : request.startClocks;
  var duration = entry ? computeResourceEntryDuration(entry) : computeRequestDuration(pageStateHistory, startClocks, request.duration);
  var graphql = request && computeGraphQlMetaData(request, configuration);
  var resourceEvent = combine({
    date: startClocks.timeStamp,
    resource: {
      id: generateUUID(),
      duration: toServerDuration(duration),
      // TODO: in the future when `entry` is required, we can probably only rely on `computeResourceEntryType`
      type: request ? request.type === RequestType.XHR ? ResourceType.XHR : ResourceType.FETCH : computeResourceEntryType(entry),
      method: request ? request.method : undefined,
      status_code: request ? request.status : discardZeroStatus(entry.responseStatus),
      url: request ? sanitizeIfLongDataUrl(request.url) : entry.name,
      protocol: entry && computeResourceEntryProtocol(entry),
      delivery_type: entry && computeResourceEntryDeliveryType(entry),
      graphql: graphql
    },
    type: RumEventType.RESOURCE,
    _dd: {
      discarded: !configuration.trackResources
    }
  }, tracingInfo, entry && computeResourceEntryMetrics(entry));
  return {
    startTime: startClocks.relative,
    duration: duration,
    rawRumEvent: resourceEvent,
    domainContext: getResourceDomainContext(entry, request)
  };
}

function computeGraphQlMetaData(request, configuration) {
  var graphQlConfig = findGraphQlConfiguration(request.url, configuration);

  if (!graphQlConfig) {
    return;
  }

  return extractGraphQlMetadata(request, graphQlConfig);
}

function getResourceDomainContext(entry, request) {
  if (request) {
    var baseDomainContext = {
      performanceEntry: entry,
      isAborted: request.isAborted,
      handlingStack: request.handlingStack
    };

    if (request.type === RequestType.XHR) {
      return _objectSpread({
        xhr: request.xhr
      }, baseDomainContext);
    }

    return _objectSpread({
      requestInput: request.input,
      requestInit: request.init,
      response: request.response,
      error: request.error
    }, baseDomainContext);
  }

  return {
    // Currently, at least one of `entry` or `request` must be defined when calling this function.
    // So `entry` is guaranteed to be defined here. In the future, when `entry` is required, we can
    // remove the `!` assertion.
    performanceEntry: entry
  };
}

function computeResourceEntryMetrics(entry) {
  var renderBlockingStatus = entry.renderBlockingStatus;
  return {
    resource: _objectSpread(_objectSpread({
      render_blocking_status: renderBlockingStatus
    }, computeResourceEntrySize(entry)), computeResourceEntryDetails(entry))
  };
}

function computeRequestTracingInfo(request, configuration) {
  var hasBeenTraced = request.traceSampled && request.traceId && request.spanId;

  if (!hasBeenTraced) {
    return undefined;
  }

  return {
    _dd: {
      span_id: request.spanId.toString(),
      trace_id: request.traceId.toString(),
      rule_psr: configuration.rulePsr
    }
  };
}

function computeResourceEntryTracingInfo(entry, configuration) {
  var hasBeenTraced = entry.traceId;

  if (!hasBeenTraced) {
    return undefined;
  }

  return {
    _dd: {
      trace_id: entry.traceId,
      span_id: createSpanIdentifier().toString(),
      rule_psr: configuration.rulePsr
    }
  };
}

function computeRequestDuration(pageStateHistory, startClocks, duration) {
  return !pageStateHistory.wasInPageStateDuringPeriod("frozen"
  /* PageState.FROZEN */
  , startClocks.relative, duration) ? duration : undefined;
}
/**
 * The status is 0 for cross-origin resources without CORS headers, so the status is meaningless, and we shouldn't report it
 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus#cross-origin_response_status_codes
 */


function discardZeroStatus(statusCode) {
  return statusCode === 0 ? undefined : statusCode;
}